module.exports = __webpack_public_path__ + "img/pc-logo.3ba09850.webp";